import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, ButtonGroup, } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import { setStatusFilter, TranslationStatus } from '../store/slices/translationsSlice';
import { selectStatusFilter } from '../store/selectors/translationsSelectors';
import { getFilterStatuses } from '../types/enums';

const TranslationFilters: React.FC = () => {
    const filtersElement = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();
    const statusFilter = useAppSelector(selectStatusFilter);

    const [statusFilterHtmlProps, setStatusFilterHtmlProps] = useState({
        width: 0,
        height: 0,
        x: 0,
    });

    const filterStatuses = getFilterStatuses();

    const handleStatusFilterChange = (e: React.MouseEvent<HTMLButtonElement>, status: TranslationStatus) => {
        setStatusFilterHtmlProps({
            width: e.currentTarget.offsetWidth,
            height: e.currentTarget.offsetHeight,
            x: e.currentTarget.offsetLeft,
        });
        dispatch(setStatusFilter(status));
    };

    useEffect(() => {

        if (filtersElement.current) {
            const currentIndex = filterStatuses.findIndex(status => status.key === statusFilter);
            const buttons = filtersElement.current.querySelectorAll('button');
            const activeButton = buttons[currentIndex];
            if (activeButton) {
                setStatusFilterHtmlProps({
                    width: activeButton.offsetWidth,
                    height: activeButton.offsetHeight,
                    x: activeButton.offsetLeft,
                });
            }
        }
    }, [statusFilter]);

    return (
        <Box sx={styles.filterBox}>
            <Box sx={styles.filterContainer} ref={filtersElement}>
                <ButtonGroup disableRipple variant="text" aria-label="Status filter button group" size='small' sx={styles.filterButtonContainer}>
                    <Box sx={{
                        ...styles.filterSelectorHighlight,
                        opacity: 0.1,
                        left: statusFilterHtmlProps.x,
                        height: statusFilterHtmlProps.height,
                        width: statusFilterHtmlProps.width,
                    }}></Box>
                    {filterStatuses.map((status) => (
                        <Button
                            key={status.key}
                            onClick={(e) => handleStatusFilterChange(e, status.key)}
                            sx={{ color: statusFilter === status.label ? 'text.primary' : 'text.secondary', textTransform: 'capitalize', px: 1.25 }}
                        >
                            {status.label}
                        </Button>
                    ))}
                </ButtonGroup>
            </Box>
        </Box>
    );
};

const styles = {
    filterBox: {
        flex: 3,
        minWidth: 200,
    },
    filterContainer: {
        backgroundColor: 'background.paper',
        borderRadius: 1,
        p: 0.5,
        width: 'fit-content',
        border: '1px solid',
        borderColor: 'grey.300'
    },
    filterButtonContainer: {
        position: 'relative',
        '& .MuiButton-root': { fontSize: '0.8125rem', fontWeight: 'medium', border: 'none' },
    },
    filterSelectorHighlight: {
        borderRadius: 1,
        position: 'absolute',
        bottom: 0,
        right: 0,
        backgroundColor: 'primary.light',
        transition: 'all 0.3s ease',
    },
};

export default TranslationFilters;
